<template>
  <div class="tw-mb-6">
    <BaseSelect
      v-model="selectedLeitura"
      :options="leituras"
      option-label="data"
      option-value="_id"
      placeholder="Selecione uma leitura"
      @update:modelValue="onChange"
    />
  </div>
</template>

<script>
import BaseSelect from '@/components/ui/v2/BaseSelect.vue';

export default {
    components: { BaseSelect },
    props: {
        leituras: {
            type: Array,
            default: () => [],
        },
        theme: {
            type: String,
            default: 'light'
        }
    },
    data() {
        return {
            selectedLeitura: "",
        };
    },
    methods: {
        onChange(valor) {
            this.$emit('changeLeitura', valor);
        },
    }
};
</script>
